'use client';

import { useParams, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { saveReferralCode } from '@/lib/utils/referralCode';

export default function ReferralRedirectPage() {
  const params = useParams();
  const router = useRouter();
  const code = params.code as string;

  useEffect(() => {
    if (code) saveReferralCode(code);
    // Redirect to signup page without referral code in URL
    router.push('/auth/signup');
  }, [code, router]);

  // Show loading state while redirecting
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <p className="text-lg">Redirecting to registration...</p>
      </div>
    </div>
  );
}
